function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFacebook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.349,
    height: 45.349,
    viewBox: "0 0 45.349 45.349",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2370"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75",
    d: "M22.675 45.349A22.675 22.675 0 0 1 0 22.675a22.675 22.675 0 0 1 45.349 0 22.674 22.674 0 0 1-22.674 22.674",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 76",
    d: "M71.519 60.637v8.377h-3.852v-8.377h-3.2v-3.4h3.2V56c0-4.59 1.914-7 5.971-7a6.666 6.666 0 0 1 2.237.362v3.361a7.678 7.678 0 0 0-1.771-.205 2.209 2.209 0 0 0-1.9.789 4.2 4.2 0 0 0-.686 2.736v1.2h4.361l-1.171 3.4z",
    transform: "translate(-47.5 -36.102)",
    style: {
      fill: "#fff"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-facebook.36e7abc53dbceb9898ae1a5644f71579.svg";